<template>
  <div>
    <template v-if="!loading">
      <invoice-header :celebration="celebration" description="Comprovante<br>de Pagamento"></invoice-header>
      <div class="container">
        <div class="row row-wrap">
          <div class="col-1 col-sm-2">
            <div class="item-box">
              <div class="item-box-header"><h4>Cliente</h4></div>
              <div class="item-box-content">
                <h5>CPF/CNPJ</h5>
                {{ customerDocument | document }}
                <br><br>
                <h5>Nome</h5>
                {{ customerName }}
              </div>
            </div>
          </div>
          <div class="col-1 col-sm-2">
            <div class="item-box">
              <div class="item-box-header"><h4>Cedente</h4></div>
              <div class="item-box-content">
                <div class="row">
                  <div class="col">
                    <h5>CPF/CNPJ</h5>
                    {{ financialDocument | document }}
                    <br><br>
                  </div>
                  <div class="col">
                    <h5>Conta Heppi</h5>
                    {{ financialAccount }}
                    <br><br>
                  </div>
                </div>
                <h5>Nome</h5>
                {{ financialName }}
              </div>
            </div>
          </div>
        </div>
        <div class="item-box">
          <div class="item-box-header"><h3>Detalhes do pagamento</h3></div>
          <div class="item-box-content">
            <div class="detais-content row row-wrap">
              <div v-if="monthReference" class="due-date col text-uppercase">
                <h5>Mês de referência</h5>
                {{ monthReference | moment('MMMM YYYY') }}
              </div>
              <div class="due-date col text-uppercase">
                <h5>Vencimento</h5>
                {{ dueDate | moment('DD MMM YYYY') }}
              </div>
              <div v-if="paymentDate" class="due-date col text-uppercase">
                <h5>Pagamento</h5>
                {{ paymentDate | moment('DD MMM YYYY') }}
              </div>
              <div class="details-total col">
                <div v-if="paymentInfo.method === 'credit_card'" class="total-value">
                  <span class="installment-qty" v-if="paymentInfo.installments > 1">{{ paymentInfo.installments }}x</span>
                  {{ paymentInfo.total / paymentInfo.installments | priceInteger }}<small>,{{ paymentInfo.total / paymentInfo.installments | priceCents }}</small>
                  <span>no cartão</span>
                </div>
                <div v-else class="total-value">
                  <span>&nbsp;</span>
                  {{ paymentInfo.total | priceInteger }}<small>,{{ paymentInfo.total | priceCents }}</small>
                  <span>no {{ paymentInfo.method | paymentMethod }}</span>
                </div>
              </div>
            </div>
            <div class="separator" />
            <template v-if="items.length > 0">
              <h5>{{ type | typeDescription }}</h5>
              <ul class="list-content">
                <li class="list-item" v-for="(item, index) in items" :key="'item-' + index">
                  <div class="list-item-qty" v-if="type !== 'fundraising'">
                    {{ item.qty }}x
                  </div>
                  <div class="list-item-content">
                    <div v-if="item.type === 'fundraising'" class="list-item-subtitle">Parcela</div>
                    <div v-if="item.type === 'renegotiation'" class="list-item-subtitle">Renegociação/Acordo</div>
                    <div v-if="item.type === 'additional'" class="list-item-subtitle">Adicional</div>
                    <div class="list-item-text">{{ item.description }}</div>
                  </div>
                  <div class="list-item-value">
                    {{ (item.value * item.qty) | priceInteger }}<small>,{{ (item.value * item.qty) | priceCents }}</small>
                  </div>
                </li>
              </ul>
            </template>
            <template v-if="discounts.length > 0">
              <h5>Descontos</h5>
              <ul class="list-content">
                <li class="list-item" v-for="(item, index) in discounts" :key="'discounts-' + index">
                  <div class="list-item-content">
                    <div class="list-item-text">{{ item.description }}</div>
                  </div>
                  <div class="list-item-value">
                    {{ item.value | priceInteger }}<small>,{{ item.value | priceCents }}</small>
                  </div>
                </li>
              </ul>
            </template>
            <template v-if="others.length > 0">
              <h5>Multa e Juros</h5>
              <ul class="list-content">
                <li class="list-item" v-for="(item, index) in others" :key="'others-' + index">
                  <div class="list-item-content">
                    <div class="list-item-text">{{ item.description }}</div>
                  </div>
                  <div class="list-item-value">
                    {{ item.value | priceInteger }}<small>,{{ item.value | priceCents }}</small>
                  </div>
                </li>
              </ul>
            </template>
            <div class="separator" />
            <div class="detais-content row row-wrap" style="max-width: 500px; margin: 0 auto">
              <div class="share-button col">
                <button class="button button-secondary" @click="shareInvoice()">
                  <img v-if="deviceType === 'ios'" src="@/assets/images/share-ios.png" srcset="@/assets/images/share-ios@2x.png 2x">
                  <img v-else src="@/assets/images/share-android.png" srcset="@/assets/images/share-android@2x.png 2x">
                  Compartilhar recibo
                </button>
              </div>
              <!-- <div class="share-button col">
                <button class="button button-secondary" @click="printReceipt()">
                  Imprimir recibo
                </button>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </template>
    <loading v-if="loading || sending" :loading-text="loadingText"></loading>
    <modal v-else-if="openSharing" modal-header="Compartilhar recibo">
      <p>Para compartilhar esse recibo com outras pessoas é só copiar o link abaixo:</p>
      <div class="form-group">
        <input ref="input-copy" class="form-input" :value="url" type="text" readonly="true">
        <div class="copy-append" :class="{ 'muted': copiedLink }" @click="copyLink()">{{ (copiedLink) ? 'Copiado!' : 'Copiar' }}</div>
      </div>
      <br><br>
      <div class="text-right">
        <button @click="openSharing = false" class="button button-outline-secondary">Fechar</button>
      </div>
    </modal>
  </div>
</template>

<script>
import InvoiceHeader from '@/components/InvoiceHeader'
import Loading from '@/components/Loading'
import Modal from '@/components/Modal'
import { mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'invoice',
  components: {
    InvoiceHeader,
    Loading,
    Modal
  },
  props: ['id'],
  data: () => {
    return {
      loading: false,
      sending: false,
      openSharing: false,
      type: null,
      monthReference: '',
      celebration: '',
      customerDocument: '',
      customerName: '',
      financialDocument: '',
      financialName: '',
      financialAccount: '',
      items: [],
      others: [],
      discounts: [],
      dueDate: '',
      paymentDate: null,
      paymentInfo: {
        method: '',
        installments: 0,
        total: 0
      },
      copiedLink: false
    }
  },
  computed: {
    url () {
      let url = window.location + ''
      return url.split('#')[0]
    },
    loadingText () {
      return (this.sending) ? 'Processando' : 'Carregando'
    },
    deviceType () {
      if (/iphone|ipad|ipod/.test(window.userAgent)) {
        return 'ios'
      } else {
        return 'android'
      }
    }
  },
  filters: {
    typeDescription (val) {
      if (val === 'fundraising') return 'Arrecadações'
      return 'Itens'
    },
    paymentMethod (val) {
      if (val === 'bank_slip') return 'boleto'
      if (val === 'credit_card') return 'cartão'
      if (val === 'pix') return 'pix'
      return val
    }
  },
  methods: {
    ...mapMutations(['SET_ERROR_PAGE']),
    shareInvoice () {
      if (navigator.share) {
        navigator.share({
          title: 'Recibo Heppi',
          text: 'Olá! Estou compartilhando com você um recibo Heppi - ' + this.celebration + '.',
          url: this.url
        })
      } else {
        this.openSharing = true
      }
    },
    getInfo () {
      let vue = this
      vue.loading = true

      axios.get('invoices/' + vue.id)
        .then((response) => {
          if (response.data && response.data.invoice_status === 'paid') {
            vue.type = response.data.product_reference
            vue.monthReference = (response.data.product_reference === 'fundraising') ? response.data.invoice_date : null
            vue.celebration = response.data.description
            vue.customerDocument = (response.data.customer) ? response.data.customer.document : ''
            vue.customerName = (response.data.customer) ? response.data.customer.name : ''
            vue.financialDocument = (response.data.account && response.data.account.owner) ? response.data.account.owner.document : ''
            vue.financialName = (response.data.account) ? response.data.account.name : ''
            vue.financialAccount = (response.data.account) ? response.data.account.account_number : ''
            if (response.data.items) {
              vue.items = response.data.items.filter(e => !['interest_and_fines', 'discount'].includes(e.category)).map(e => {
                return {
                  qty: e.quantity,
                  type: e.category,
                  description: e.description,
                  value: e.amount
                }
              })
              vue.others = response.data.items.filter(e => e.category === 'interest_and_fines').map(e => {
                return {
                  description: e.description,
                  value: e.amount
                }
              })
              vue.discounts = response.data.items.filter(e => e.category === 'discount').map(e => {
                return {
                  description: e.description,
                  value: e.amount
                }
              })
            }
            vue.dueDate = response.data.due_date
            vue.paymentDate = response.data.payment_date
            vue.paymentInfo = {
              method: (response.data.payment_method) ? response.data.payment_method : '',
              installments: (response.data.installments) ? response.data.installments : 0,
              total: (response.data.total_amount) ? response.data.total_amount : 0
            }
          } else {
            vue.SET_ERROR_PAGE('Error404')
          }

          vue.loading = false
        })
        .catch((error) => {
          if (error.response && error.response.status === '404') {
            vue.SET_ERROR_PAGE('Error404')
          } else {
            vue.SET_ERROR_PAGE('Error500')
          }
        })
    },
    copyLink () {
      const codeToCopy = this.$refs['input-copy']
      codeToCopy.select()
      codeToCopy.setSelectionRange(0, 99999)
      document.execCommand('copy')

      this.copiedLink = true
      setTimeout(() => {
        this.copiedLink = false
        window.getSelection().removeAllRanges()
      }, 6000)
    } /* ,
    printReceipt () {
      window.print()
    } */
  },
  created () {
    if (this.id) {
      this.getInfo()
    } else {
      this.SET_ERROR_PAGE('Error404')
    }
  }
}
</script>
